import React from 'react';
import Logo from '../../../assets/images/brand/logo-white-color.svg';
import LogoMobile from '../../../assets/images/brand/logo-black.png';
import BannerLogin from '../../../assets/images/banners/banner_login.png';
import StateraLogo from '../../../assets/images/b2b/statera/statera-logo.png'
import { Button } from '../../../core/components/atoms/Button';
import { useForm } from 'react-hook-form';
import { ILoginCredentials } from '../models/user.model';
import { useLogin } from '../hooks/useLogin';
import { Input } from '../../../core/components/atoms/Input';
import { Alert } from '../../../core/components/atoms/Alert';
import { Link } from 'react-router-dom';
import { Typography } from '../../../core/components/molecules/Typography';
import { EMAIL_REGEX } from 'morpheus-ui';
import Login_CHALLENGE from '../../../assets/images/banners/banner_login.png'

export default function LoginChallenge({ origin, companyName }: { origin: string, companyName?: string }): React.JSX.Element {
  const [inputType, setInputType] = React.useState<string>('password');

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ILoginCredentials>();

  const isStatera = companyName === 'statera'

  const { loginUser, isLoading, isError } = useLogin(origin);

  const onSubmit = (data: ILoginCredentials) => {
    loginUser(data);
  };

  return (
    <div
      className='md:center flex h-screen flex-col items-center
         justify-center md:flex-row'
    >
      {/* Coluna Esquerda (Imagem) */}
      {isStatera ? <div className='hidden items-center justify-center bg-brand-color-primary-dark md:flex md:h-screen md:w-1/2'>
          <img
            src={StateraLogo}
            alt='Imagem de Login'
            className='max-w-xs pb-12 md:pb-0'
          />
        </div> :
        <div className='hidden items-center justify-center bg-brand-color-primary-dark md:flex md:h-screen md:w-1/2'>
          <div className='relative z-10 flex flex-col items-center px-4 md:px-8 lg:px-12'>
            <img
              src={Logo}
              alt='Imagem de Login'
              className='max-w-xs pb-[54px]'
            />
            <Typography
              size='h2'
              type='title'
              weight='bold'
              className='!text-white text-center w-full max-w-[545px] px-4'
              style={{ color: '#ffffff' }}
            >
              Conquiste sua vaga na <br /> universidade em tempo recorde!
            </Typography>
            <Typography
              size='default'
              className='!text-white text-center mt-[5px] px-4'
              style={{ color: '#ffffff' }}
            >
              O Aprova Total te leva até 10x mais rápido. <br />
              <span className='font-bold'>Experimente por 7 dias sem riscos!</span>
            </Typography>
            <Button
              variant="contained"
              size="large"
              className="mt-[54px] mx-4"
              asLink={true}
              to="https://checkout.aprovatotal.com.br/lead?seller=performance&source=plataforma-aprovatotal-login&utm_source=plataforma&utm_medium=login&utm_campaign=plataforma&utm_content=banner-de-o-primeiro-passo-agora"
              target="_blank"
              style={{
                backgroundColor: '#FF5227',
                borderRadius: '8px',
                padding: '8px 16px'
              }}
            >
              Assine e dê o primeiro passo agora!
            </Button>
          </div>
          <img
            src={Login_CHALLENGE}
            alt='Banner de Login'
            className='absolute h-full w-1/2 object-cover left-0'
          />
        </div> }

      {/* Coluna Direita (Formulário) */}
      <div
        className='relative flex h-screen w-full
                             flex-col items-center justify-center p-4 md:w-1/2'
        style={{ backgroundColor: '#E6EBF0' }}
      >
        <img
          src={isStatera ? StateraLogo : LogoMobile}
          alt='Imagem de Login'
          className='z-10 max-w-xs pb-12 md:hidden md:pb-0'
        />

        <div className='z-10 text-center'>
          <div
            className='rounded-lg p-6 shadow-level-4'
            style={{ backgroundColor: '#FFFFFF' }}
          >
            <Typography size='h2' type='title' weight='bold' className='mb-2'>
              Entrar
            </Typography>
            <Typography size='default' className='mb-5'>
              {isStatera ? "Faça login para acessar" :
                <span>Faça login para acessar o aplicativo <br/> do Aprova</span>}
            </Typography>

            {isError && (
              <Alert
                variant='error'
                title='E-mail ou senha inválidos'
                message='Revise os dados e tente novamente.'
                className='mb-4'
              />
            )}

            <form onSubmit={handleSubmit(onSubmit)} className='text-left'>
              <div className='mb-4'>
                <Input
                  {...register('email', {
                    required: true,
                    pattern: EMAIL_REGEX,
                    validate: value => value === value.toLowerCase(),
                    onChange: (e) => setValue('email', e.target.value.toLowerCase())
                  })}
                  label='E-mail'
                  placeholder='E-mail'
                  errorMessage={errors.email && 'Digite um e-mail válido.'}
                  IconLeft={{
                    type: 'material',
                    Icon: 'account_circle',
                  }}
                />
              </div>
              <div className='mb-4'>
                <Input
                  {...register('password', { required: true })}
                  label='Senha'
                  placeholder='Senha'
                  type={inputType}
                  errorMessage={errors.password && 'Digite sua senha.'}
                  IconLeft={{
                    type: 'material',
                    Icon: 'lock',
                  }}
                  IconRight={{
                    type: 'material',
                    Icon:
                      inputType === 'password'
                        ? 'visibility_off'
                        : 'visibility',
                    className: 'cursor-pointer',
                    onClick: () => {
                      setInputType(
                        inputType === 'password' ? 'text' : 'password'
                      );
                    },
                  }}
                />
              </div>

              {!isStatera && <Typography size='small' className='mb-4 text-left'>
                <Link to={'/recuperar-senha'} style={{ color: '#1B229F' }}>Esqueci minha senha</Link>
              </Typography> }

              <Button loading={isLoading} variant='contained' size='large' full>
                Entrar
              </Button>

              {!isStatera && (
                <>
                  <div className="my-4 flex items-center gap-3">
                    <span className="h-px flex-1 bg-mono-200" />
                    <Typography size="small" className="text-mono-500">
                      ou
                    </Typography>
                    <span className="h-px flex-1 bg-mono-200" />
                  </div>
                </>
              )}
            </form>
          </div>
          {!isStatera && <Typography size='small' className='pt-5'>
            Não tem um plano?
            <a
              href='https://checkout.aprovatotal.com.br/lead?seller=performance&source=plataforma-aprovatotal-login&utm_source=plataforma&utm_medium=cpa-login&utm_campaign=plataforma&utm_content=assine-agora-mesmo'
              className='text-primary-500 underline'
              style={{ color: '#1B229F' }}
            >
              {' '}
              Assine agora mesmo!
            </a>
          </Typography> }
        </div>
      </div>
    </div>
  );
}
